var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MonthlyField',{ref:"otherPeriodField",attrs:{"type":"monthly","disabled":false,"min":_vm.min,"max":_vm.max},on:{"cancelDateSelected":_vm.cancelDateSelected,"applyDateSelected":function($event){return _vm.applyDateSelected($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }